export default {
	'custom-cloud-download': {
		width: 35,
		height: 35,
		/* eslint-disable max-len */
		d: 'M23.3583333,15.875 C25.3375,16.0375 27,17.825 27,19.9375 C27,22.2125 25.2583333,24 23.0416667,24 L12.75,24 C10.1375,24 8,21.80625 8,19.125 C8,16.60625 9.82083333,14.575 12.275,14.25 C13.225,12.3 15.2041667,11 17.5,11 C20.4291667,11 22.8041667,13.1125 23.3583333,15.875 Z M19.0833333,17.5 L19.0833333,14.25 L15.9166667,14.25 L15.9166667,17.5 L13.5416667,17.5 L17.5,21.5625 L21.4583333,17.5 L19.0833333,17.5 Z'
	}
};
